import { Form } from '@rjsf/mui';
import validator from '@rjsf/validator-ajv8';
import { useQuery } from '@tanstack/react-query';
import { client, url } from '../api';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { LoadingSpinner } from 'design-system/src/components/LoadingSpinner/LoadingSpinner';

import { convertTimestamps } from '../utils';

export const FormDemo: React.FC = () => {
  const [staticInformation, setStaticInformation] = useState({} as any);
  const { type } = useParams<{ type: string }>();
  const query = useQuery({
    queryKey: ['form-schema'],
    queryFn: () => client.get(url(`/form-schema/${type}`)).then((res) => res.data),
  });

  if (query.isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div>
      <h1 style={{ marginLeft: '24px' }}>Form Demo</h1>
      <Container>
        <StaticInfo>
          <h2>Static Information</h2>
          <Form
            schema={query.data.form_schema.definitions.sections.staticInformation}
            validator={validator}
            omitExtraData={true}
            liveOmit={true}
            formData={staticInformation}
            onChange={(e) => setStaticInformation(e.formData)}
          >
            <div></div>
          </Form>
        </StaticInfo>
        <FormContainer>
          <h2>Task Form</h2>
          <Form
            schema={query.data.form_schema}
            uiSchema={query.data.ui_schema}
            formData={staticInformation}
            validator={validator}
            omitExtraData={true}
            liveOmit={true}
            onChange={(e) => {
              // eslint-disable-next-line no-console
              console.log(e);
            }}
            onSubmit={(e) => {
              const data = convertTimestamps(e.formData);
              // eslint-disable-next-line no-console
              console.log(data);
            }}
          ></Form>
        </FormContainer>
      </Container>
    </div>
  );
};

const Container = styled.div`
  display: flex;
  background-color: white;
`;

const StaticInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  width: 300px;
  flex-shrink: 0;
`;

const FormContainer = styled.div`
  padding: 24px;
  flex-grow: 1;
`;
